import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion";
import { sectors } from "@/data/sectors";

export default function Industries() {
  return (
    <section className="bg-ink text-white sec" data-testid="industries-section">
      <div className="wrap">
        <Reveal>
          <h2 className="h-display font-bold text-[32px] sm:text-5xl lg:text-[56px] leading-[1.06] mb-14">
            ESG & Sustainability across industries.
          </h2>
        </Reveal>
        <div className="border-t rule-dark" data-testid="industries-list">
          {sectors.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.05}>
              <Link
                to={`/solutions#${s.slug}`}
                className="group flex items-baseline gap-5 sm:gap-8 border-b rule-dark py-6 sm:py-8"
                data-testid={`industry-row-${s.slug}`}
              >
                <span className="font-mono text-[11px] text-white/55 w-7 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="flex-1 h-display font-bold text-[22px] sm:text-3xl lg:text-4xl text-white group-hover:text-gold transition-colors duration-300">
                  {s.name}
                </h3>
                <ArrowUpRight size={20} className="hidden sm:block text-white/45 group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300 shrink-0 self-center" />
              </Link>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <p className="text-white/88 text-[13px] mt-6 hidden sm:block">Hover an industry for its focus — or explore all solutions.</p>
        </Reveal>
      </div>
    </section>
  );
}
